// useHasUnreadChat.js
import { useEffect, useState, useRef } from 'react';
import TencentCloudChat from '@tencentcloud/chat';

const SDK_APP_ID = 20043073; // same SDKAppID used by the widget

export function useHasUnreadChat() {
  const [hasUnread, setHasUnread] = useState(false);
  const chatRef = useRef(null);
  const [refreshKey, setRefreshKey] = useState(0); // bump to force reinit on login/logout

  // re-run init whenever identity changes
  useEffect(() => {
    const bump = () => setRefreshKey((k) => k + 1);
    window.addEventListener('site:login', bump);
    window.addEventListener('site:logout', bump);
    window.addEventListener('itone:login', bump);
    window.addEventListener('itone:logout', bump);
    return () => {
      window.removeEventListener('site:login', bump);
      window.removeEventListener('site:logout', bump);
      window.removeEventListener('itone:login', bump);
      window.removeEventListener('itone:logout', bump);
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function init() {
      // tear down any previous session first (e.g. guest -> real login)
      if (chatRef.current) {
        await chatRef.current.logout().catch(() => {});
        chatRef.current.destroy();
        chatRef.current = null;
      }

      const chat = TencentCloudChat.create({ SDKAppID: SDK_APP_ID });
      chatRef.current = chat;

      chat.on(TencentCloudChat.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED, (event) => {
        console.debug('useHasUnreadChat unread count:', event.data);
        if (!cancelled) setHasUnread((event.data || 0) > 0);
      });
      const params = new URLSearchParams({ siteID: 'bellagio' });


      const res = await fetch(`api/tencent/chatwidget/login?${params}`);
      const creds = await res.json();
      if (!creds.success || cancelled) {
        console.warn('Chat badge init aborted:', creds);
        return;
      }

      // creds.userID is whatever the backend assigned — Guest_xxx or the real account
      await chat.login({ userID: creds.userID, userSig: creds.userSig });
      console.debug('Badge chat instance logged in as:', creds.userID);
    }

    init();

    return () => {
      cancelled = true;
      chatRef.current?.destroy();
    };
  }, [refreshKey]);

  return hasUnread;
}